// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14gQc","left":"styles_left__2oPP-","desktopActions":"styles_desktopActions__2OUGR","title":"styles_title__NsQob"};